export const convertIntoLakh = (amount) => {
    const numericAmount = Number(amount);
    if (!isNaN(numericAmount) && numericAmount > 0) {
        if (numericAmount >= 10000000) {
            return `₹ ${(numericAmount / 10000000).toFixed(0)} Cr`;
        } else if (numericAmount >= 100000) {
            return `₹ ${(numericAmount / 100000).toFixed(0)} Lakh`;
        } else if (numericAmount >= 1000) {
            return `₹ ${(numericAmount / 1000).toFixed(0)} Thousand`;
        }
        return `₹ ${numericAmount.toFixed(0)}`;
    }
    return "₹ 0";
};

export const CommaSeprator = (input) => {
    if (input !== null && input !== undefined) {

        let value = input;
        let rupee = value.toString();
        let newRupee = rupee.substring(rupee.length - 3);
        let other = rupee.substring(0, rupee.length - 3);
        if (other !== '')
            newRupee = ',' + newRupee;
        //console.log(newRupee);
        let formatedValue = other.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + newRupee;
        return formatedValue;
    }
};